import type { FilterProps } from './Filter.types';
import { FilterButton } from './FilterButton';

export default function Filter<ValueType extends string>(props: FilterProps<ValueType>) {
  const { options, variant = 'contained', value, onValueChange } = props;

  const variantClassName =
    variant === 'contained'
      ? 'p-[8px] bg-pmw-sb-2-tertiary-light dark:bg-pmw-sb-2-tertiary-dark'
      : 'p-[4px] bg-pmw-sb-2-secondary-light dark:bg-pmw-sb-2-secondary-dark border border-pmw-separator-light dark:border-pmw-separator-dark';

  return (
    <div
      className={`flex gap-[10px] rounded-full font-robotoMedium text-[12px] ${variantClassName}`}
    >
      {options.map((option) => (
        <FilterButton
          key={option.value}
          label={option.label}
          isActive={option.value === value}
          onClick={() => onValueChange?.(option.value)}
        />
      ))}
    </div>
  );
}
